import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "D:/work/BC_Supermarket/bc-supermarket-docs-docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1 {...{
      "id": "customization"
    }}>{`Customization`}</h1>
<p>{`This page will explain all configuration available and how to edit each section appear on theme. Let's view the first homepage.`}</p>
<p><img alt="Homepage of Default Style" src={require("../img/home1.jpg")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      